export default "__VITE_ASSET__BVzyDALb__"